import React, { Component } from 'react'
import { connect } from 'react-redux'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { mode, IMP_CODE, IMP_PG, IMP_PG_KAKAOPAY_PAYMENT, IMP_PG_KAKAOPAY_BILLING } from 'webconfig'
import axios from 'axios'
import './Order.scss'

import CouponPopup from './CouponPopup'
import i18n from '../i18n'
import { Trans } from 'react-i18next'
import { FetchCoupons, UpdateCurrentCredit } from '../Interface'
import Loading from '../Common/loading/loading'
import Uploading from '../Common/Uploading/Uploading'
import UploadCompleted from '../Common/UploadCompleted/UploadCompleted'
import DataManager from '@/utils/DataManager'
import { PRODUCT_TYPE } from '@/utils/Global'
import ProviderHelper from '@/utils/DataManager/ProviderHelper'

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const currencyTable = {
    KRW: "₩",
    JPY: "¥",
    USD: "$",
    VND: "₫",
    THB: "฿",
    IDR: "Rp"
}

class OrderClass extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            productInfo: null,
            method: 'inicis',
            whatSelected: null,
            isCouponPopupOpen: false,
            couponCode: '',
            selectedCoupon: null,
            isAgreed: false,
            isUploadCompletedOpened: false
        }
    }

    async componentDidMount() {
        window.scrollTo({ top: 0, left: 0 })

        const isKo = this.props.value === "ko"

        this.setState({ whatSelected: isKo ? 'inicis' : 'paypal_v2' })

        await FetchCoupons()
        await this.getProductInfo()

        const product = this.getPaymentInfoByType()
        if (!product) return

        if (product.payple) this.setState({ method: 'payple' })
        else if (product.inicis) this.setState({ method: 'inicis' })
        else if (product.kakaopay) this.setState({ method: 'kakaopay' })
        else if (product.stripe) this.setState({ method: 'stripe' })
        else if (product.naverpay) this.setState({ method: 'naverpay' })
        else if (product.paypal_v2) this.setState({ method: 'paypal_v2' })

        const couponCode = sessionStorage.getItem("couponCode")
        if (couponCode) this.setState({ couponCode: couponCode.toUpperCase() })

        this.autoSelectCoupon()
    }

    getProductInfo = async () => {
        if (!this.props.location.state) return this.props.history.push('/payment')

        const { productId, selectedTemplateId: templateId, videoId } = this.props.location.state
        if (!productId) return this.props.history.push('/payment')

        try {
            const response = await axios.get(`${GetBaseUrl()}/api/product/info?id=${productId}`)
            if (response && response.data && response.data.info) {
                const { _id, name, price, productName, currency, type, validity } = response.data.info

                if (type === 'WatermarkPayment' && (!templateId || !videoId)) return this.props.history.push('/payment')

                this.setState({
                    productInfo: {
                        type,
                        productId: _id,
                        productName,
                        productPrice: price,
                        currency: currency,
                        gaDescription: name,
                        validity
                    }
                })
            }
        }
        catch (e) {
            if (e && e.response && e.response.status === 404) {
                alert("판매가 종료된 상품입니다.");    
            }
            return this.props.history.push('/payment')
        }
    }

    getPaymentInfoByType = () => {
        const { productInfo } = this.state
        if (!productInfo) return null

        if (productInfo.currency === 'KRW') {
            productInfo.inicis = true
            productInfo.kakaopay = true
            productInfo.naverpay = true
        }
        else {
            productInfo.paypal_v2 = true;
            // productInfo.paypal = true;
        }

        return productInfo
    }

    calculateFinalPrice = productPrice => {
        const { selectedCoupon, method } = this.state
        let finalPrice = Number(productPrice)

        if (selectedCoupon) {
            const { data: { action, value } } = selectedCoupon
            if (action === 'DiscountAll') finalPrice = 0
            else if (action === 'DiscountPercentage' && method === 'stripe') finalPrice = finalPrice * (1 - value)
            else if (action === 'DiscountPercentage') finalPrice = Math.floor(finalPrice * (1 - value))
            else if (action === 'DiscountAmount') finalPrice -= value
        }

        return finalPrice
    }

    autoSelectCoupon = () => {
        const { coupons } = this.props

        if (Array.isArray(coupons)) {
            const { productId } = this.props.location.state
            for (let i = 0; i < coupons.length; i++) {
                const { data } = coupons[i]
                if (data && Array.isArray(data.productId)) {
                    for (let j = 0; j < data.productId.length; j++) {
                        if (String(productId) === String(data.productId[j])) {
                            this.setState({ selectedCoupon: coupons[i] })
                            return
                        }
                    }
                }
            }
        }
    }

    useDiscountAllCoupon = async () => {
        const { productId, selectedTemplateId: templateId, videoId } = this.props.location.state

        const productInfo = this.getPaymentInfoByType()
        if (!productId || !productInfo || !this.props.currentUser) return
        const { type } = productInfo
        const { selectedCoupon } = this.state

        this.setState({ isLoading: true })
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${GetBaseUrl()}/apis/payments/free-payment`,
                {
                    productId,
                    templateId,
                    videoId,
                    couponId: selectedCoupon._id
                },
                { headers: { Authorization: `Bearer ${token}` } }
            )

            if (type === 'WatermarkPayment') this.props.history.push('/user/_')
            else this.props.history.push('/')
        }
        catch (e) {
            alert(i18n.t("OrderReview.alert.error.order"))
        }
        this.setState({ isLoading: false })
    }

    sendGAPurchaseEvent = async paymentId => {
        const productInfo = this.getPaymentInfoByType()
        if (!productInfo) return
        
        const {
            currency,
            gaDescription,
            productId,
            productPrice
        } = productInfo
    
        const calculatedPrice = this.calculateFinalPrice(productPrice)
        
        if (mode === 'stage') {
            // ReactGA.event({
            //   category: 'user',
            //   action: 'purchase'
            // })
        
            // ReactGA.set({ currencyCode: currency })
        
            // ReactGA.plugin.execute('ec', 'addProduct', {
            //   id: productId,
            //   name: gaDescription,
            //   price: calculatedPrice,
            //   quantity: 1,
            //   currency
            // })
            // ReactGA.plugin.execute('ec', 'setAction', 'purchase', {
            //   id: paymentId,
            //   revenue: calculatedPrice,
            //   tax: 0,
            //   shipping: 0,
            //   currency
            // })
            // ReactPixel.trackCustom("Purchase", {
            //   value: calculatedPrice,
            //   currency: currency,
            //   content_type: 'product',
            //   compared_product: gaDescription,
            //   contents: [
            //     {
            //       id: productId,
            //       paymentId: paymentId,
            //       quantity: 1
            //     }
            //   ]
            // })
            
            if (Array.isArray(window.dataLayer)) {
                window.dataLayer.push({ event: 'tag_purchase' })
        
                window.dataLayer.push({
                    event: 'tag_transaction',
                    ecommerce: {
                        currencyCode: currency,
                        purchase: {
                            actionField: {
                                id: paymentId,
                                revenue: String(calculatedPrice),
                                tax: '0',
                                shipping: '0',
                                coupon: ''
                            },
                            products: [{
                                name: gaDescription + '_TAG',
                                id: productId,
                                price: calculatedPrice,
                                quantity: 1,
                                coupon: ''
                            }]
                        }
                    }
                })
            }
        }
    }

    handleAgreementDialogOpen = () => {
        this.setState({ isUploadCompletedOpened: true })
    }

    handleCloseUploadCompletedDialog = page => e => {
        this.setState({ isUploadCompletedOpened: false })
    }

    handleCloseDialog = () => {
        this.setState({ isUploadCompletedOpened: false })
    }

    handleClickCouponPopupBtn = () => {
        this.setState({ isCouponPopupOpen: true })
    }

    handleClickCloseCouponPopup = () => {
        this.setState({ isCouponPopupOpen: false, couponCode: '' })
    }

    handleChangeCouponCode = e => {
        let { value } = e.target

        if (typeof value === 'string') {
            value = value.toUpperCase()
        }

        this.setState({ couponCode: value })
    }

    handleSelectCoupon = coupon => {
        this.setState({ selectedCoupon: coupon })
    }

    handleCancelCouponSelect = () => {
        this.setState({ selectedCoupon: null })
    }

    handleChangeCheckbox = value => () => {
        if (value === 'inicis' || value === 'paypal' || value === 'kakaopay' || value === 'naverpay') this.setState({ method: value })
        else this.setState({ method: value })

        this.setState({ whatSelected: value })
    }

    handleClickRegisterCouponBtn = async e => {
        const { couponCode } = this.state
        if (!couponCode || couponCode.length === 0) return

        try {
            const token = localStorage.getItem('token')
            await axios.post(`${GetBaseUrl()}/apis/coupons/issue`, 
                { code: couponCode },
                { headers: { Authorization: `Bearer ${token}` } }
            )

            await FetchCoupons()
            this.autoSelectCoupon()

            alert(i18n.t('monsterpoint.register.success.text'))
            this.setState({ couponCode: '' })
        }
        catch (err) {
            if (err && err.response && err.response.data) {
                const { error_code } = err.response.data
                switch (error_code) {
                    case 'ERR_NOT_FOUND': return alert(i18n.t("monsterpoint.register.fail.not.found"))
                    case 'ERR_ALREADY_EXIST': return alert(i18n.t("monsterpoint.register.fail.already.exists"))
                    default: return alert(i18n.t("monsterpoint.register.fail.text"))
                }
            }
            alert(i18n.t("monsterpoint.register.fail.text"))
        }
        sessionStorage.removeItem("couponCode")
    }

    handleClickAgreement = () => {
        const { isAgreed } = this.state
        this.setState({ isAgreed: !isAgreed })
    }

    handleClickOrderPaypal = () => {
      const { isAgreed, selectedCoupon } = this.state;
      if (!isAgreed) return this.handleAgreementDialogOpen();
      const { userId, email, _id } = this.props.currentUser;
      const {
        productPrice,
        currency,
        gaDescription,
      } = this.state.productInfo;
      const {
        productId,
        selectedTemplateId,
        videoId,
      } = this.props.history.location.state;
      this.props.history.push("/payment/paypal", {
        productId,
        templateId: selectedTemplateId,
        amount: this.calculateFinalPrice(productPrice),
        currency: currency,
        email,
        name: userId,
        userId: _id,
        productName: gaDescription,
        couponId: selectedCoupon ? selectedCoupon._id : null,
        selectedCoupon,
        videoId,
      });
    };

    handleClickOrderBtn = () => {
        const { method, selectedCoupon } = this.state
        if (selectedCoupon && selectedCoupon.data && selectedCoupon.data.action === 'DiscountAll') return this.useDiscountAllCoupon()

        switch (method) {
            case 'stripe': this.handleClickOrderStripe(); break
            case 'paypal_v2': this.handleClickOrderPaypal(); break;
            case 'inicis':
            case 'kakaopay':
            case 'paypal':
            case 'naverpay':
            default: this.handleClickOrderIamport(); break
        }
    }

    handleClickOrderStripe = () => {
        const { isAgreed } = this.state
        if (!isAgreed) return this.handleAgreementDialogOpen()

        this.orderStripe()
    }

    orderStripe = async () => {
        const { productId } = this.props.history.location.state
        const productInfo = this.getPaymentInfoByType()

        if (!productId || !productInfo || !this.props.currentUser) return

        const { type } = productInfo

        const { method, selectedCoupon } = this.state

        let pgType = method
        let couponId = null
        if (selectedCoupon) couponId = selectedCoupon._id

        try {
            // 워터마크 제거
            const item = { productId, pgType, couponId }
            if (type === 'PerPayment') {
                const { selectedTemplateId: templateId } = this.props.history.location.state
                item.templateId = templateId
            }
            else if (type === 'WatermarkPayment') {
                const { selectedTemplateId: templateId, videoId } = this.props.history.location.state
                item.templateId = templateId
                item.videoId = videoId
            }

            this.setState({ isLoading: true })

            const preparePayment = await axios.post(
                `${GetBaseUrl()}/apis/payments/prepare`,
                item,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .catch(error => { throw new Error(error) })

            if (
                preparePayment &&
                preparePayment.status === 200 &&
                preparePayment.data &&
                preparePayment.data.data &&
                preparePayment.data.data.paymentId
            ) {
                if (type === 'SubscriptionPayment' && pgType === 'stripe' && preparePayment.data.data.billingCustomerId) {
                    throw new Error('preparePayment 마지막 response 실패')
                }

                const preparePaymentData = preparePayment.data.data
                const { paymentId } = preparePaymentData

                try {
                    const response = await axios.post(
                        `${GetBaseUrl()}/apis/payments/stripe/checkout-session`,
                        { id: paymentId },
                        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
                    )

                    window.location.assign(response.data.data.sessionUrl)
                }
                catch (err) {
                    await this.clientPaymentFailed(preparePaymentData)
                }
            }
            else {
                throw new Error('preparePayment 마지막 response 실패')
            }
        }
        catch (err) {
            if (type === 'TermPayment') this.termPaymentError('Error', err)
            if (type === 'SubscriptionPayment') this.subscriptionPaymentError(i18n.t("OrderReview.alert.error.subscriptionPaymentError"), err)
        }
    }
    
    handleClickOrderIamport = () => {
        const { isAgreed } = this.state
        if (!isAgreed) return this.handleAgreementDialogOpen()

        this.orderIamport()
    }

    orderIamport = async () => {
        const { productId } = this.props.history.location.state
        const productInfo = this.getPaymentInfoByType()

        if (!productId || !productInfo || !this.props.currentUser) return

        const {
            type,
            gaDescription: productName,
            productPrice,
            currency
        } = productInfo

        let { email } = this.props.currentUser
        const { userId } = this.props.currentUser
        const { method, selectedCoupon } = this.state

        if (ProviderHelper.IsProvider(ProviderHelper.PROVIDER.CAFE24)) {
            const { provider } = this.props.currentUser
            if (provider && provider.cafe24 && provider.cafe24.email) {
                email = provider.cafe24.email
            }
        }
        
        let pgType = method
        let pg, payMethod, couponId
        if (selectedCoupon) couponId = selectedCoupon._id

        if (pgType === 'inicis') {
            pg = type === 'SubscriptionPayment' ? IMP_PG : 'html5_inicis'
            pgType = undefined
            payMethod = 'card'
        }
        else if (pgType === 'kakaopay') pg = type === 'SubscriptionPayment' ? IMP_PG_KAKAOPAY_BILLING : IMP_PG_KAKAOPAY_PAYMENT
        else {
            pg = pgType
            payMethod = pgType === 'eximbay' ? this.state.whatSelected : 'card' // TODO
        }

        this.setState({ isLoading: true })

        try {
            // 워터마크 제거
            const item = { productId, pgType, couponId }
            if (type === 'PerPayment') {
                const { selectedTemplateId: templateId } = this.props.history.location.state
                item.templateId = templateId
            }
            else if (type === 'WatermarkPayment') {
                const { selectedTemplateId: templateId, videoId } = this.props.history.location.state
                item.templateId = templateId
                item.videoId = videoId
            }

            const preparePayment = await axios.post(
                `${GetBaseUrl()}/apis/payments/prepare`,
                item,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .catch(error => { throw new Error(error) })

            if (
                preparePayment &&
                preparePayment.status === 200 &&
                preparePayment.data &&
                preparePayment.data.data &&
                preparePayment.data.data.paymentId
            ) {
                if (type === 'SubscriptionPayment' && (pgType !== 'stripe' && !preparePayment.data.data.billingCustomerId)) {
                    throw new Error('preparePayment 마지막 response 실패')
                }

                const addParams = {}
                if (pgType === 'naverpay') {
                    pg = pgType
                    addParams['naverPopupMode'] = false  

                    // NaverPay 에서 지정해준 값들만 넣어야함. (아래 링크 참고)
                    // https://developer.pay.naver.com/docs/v2/api#etc-etc_product

                    addParams['naverProducts'] = [{
                        "categoryType": "ETC", // (필수)무조건 대문자만 허용됨
                        "categoryId": "ETC", // (필수)무조건 대문자만 허용됨
                        "uid": productId,
                        "name": productName,
                        "count": 1
                    }]
                    //한 명의 고객이 동일 상품을 중복 결제할 수 없도록 하려면 naverProductCode를 지정해주세요. (누락되면 랜덤값으로 자동 생성)
                    // addParams['naverProductCode'] = productId
                }

                const preparePaymentData = preparePayment.data.data

                const payRequestBody = {
                    pg,
                    pay_method: payMethod,
                    merchant_uid: preparePaymentData.paymentId,
                    name: productName,
                    amount: this.calculateFinalPrice(productPrice),
                    currency,
                    buyer_email: email,
                    buyer_name: userId,
                    m_redirect_url: `${GetBaseUrl()}/apis/payments/complete/mobile`,
                    ...addParams,
                    custom_data: { productId }
                }

                if (type === 'PerPayment') payRequestBody.custom_data.templateId = item.templateId
                else if (type === 'WatermarkPayment') {
                    payRequestBody.custom_data.templateId = item.templateId
                    payRequestBody.custom_data.videoId = item.videoId
                }
                else if (type === 'SubscriptionPayment') payRequestBody.customer_uid = preparePaymentData.billingCustomerId

                const IMP = window.IMP
                IMP.init(IMP_CODE)

                IMP.request_pay(payRequestBody, async rsp => {
                    if (rsp.success) {
                        try {
                            const { buyer_email, imp_uid, pay_method, card_name } = rsp
                            let { merchant_uid } = rsp

                            await axios.patch(
                                `${GetBaseUrl()}/apis/payments/complete`,
                                {
                                    paymentId: merchant_uid,
                                    cardName: card_name || i18n.t("OrderReview.card"),
                                    paymentMethod: pay_method || i18n.t("OrderReview.card"),
                                    buyerEmail: buyer_email || ''
                                },
                                {
                                    headers: {
                                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                                        'Content-Type': 'application/json'
                                    }
                                }
                            )

                            let paymentSuccess = false
                            // pgType === undefined => inicis
                            if (type === 'SubscriptionPayment' && (pgType === 'naverpay' || pgType === undefined)) {
                                for (let i = 0; i < 180; i++) {
                                    try {
                                        await sleep(1000)
                                        const response = await axios.get(
                                            `${GetBaseUrl()}/apis/payments/${merchant_uid}/charge-subscription-id`,
                                            { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
                                        )
                                        const { chargeSubscriptionId } = response.data.data
                                        merchant_uid = chargeSubscriptionId
                                        break
                                    }
                                    catch (e) {
                                        merchant_uid = null
                                        alert(i18n.t("OrderReview.alert.error.order"))
                                        break
                                    }
                                }
                            }

                            if (merchant_uid) {
                                for (let i = 0; i < 180; i++) {
                                    try {
                                        await sleep(1000)
                                        const response = await axios.get(
                                            `${GetBaseUrl()}/apis/payments/${merchant_uid}/webhook-info`,
                                            { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
                                        )
                                        const { result, errorLog } = response.data.data
    
                                        if (result !== "Success") {
                                            if (errorLog && errorLog.isFromIamportMessage && errorLog.message) {
                                                alert(errorLog.message)
                                            }
                                            else {
                                                alert(i18n.t("OrderReview.alert.error.order"))
                                            }
                                            paymentSuccess = false
                                            break
                                        }
    
                                        paymentSuccess = true
                                        break
                                    }
                                    catch (err) {
                                        if (err && err.response && err.response.data && err.response.data) {
                                            const { error_code, message } = err.response.data
                                            if (message === 'error' && error_code === "ERR_FORGERY") {
                                                alert(i18n.t("OrderReview.alert.error.forgery"))
                                                break
                                            }
                                        }
                                    }
                                } 
                            }

                            if (paymentSuccess) {
                                if (type === 'PerPayment') this.perPaymentSuccess(item.templateId, merchant_uid)
                                else if (type === 'WatermarkPayment') this.watermarkPaymentSuccess()
                                else if (type === 'TermPayment') this.termPaymentSuccess()
                                else if (type === 'SubscriptionPayment') this.subscriptionPaymentSuccess()
                                else if (type === "IssueCoupon") this.issueCouponPaymentSuccess()

                                UpdateCurrentCredit();

                                this.sendGAPurchaseEvent(merchant_uid);
                            }
                        }
                        catch (err) {
                            if (type === 'PerPayment' || type === 'WatermarkPayment') alert(i18n.t("OrderReview.alert.error.perpayment"))
                            else if (type === 'TermPayment') this.termPaymentFailed('Error', err)
                            else if (type === 'SubscriptionPayment') this.subscriptionPaymentFailed(i18n.t("OrderReview.alert.error.subscriptionPaymentFailed"), err)
                            else if (type === "IssueCoupon") this.issueCouponPaymentFailed("번들 결제가 실패하였습니다", err)
                            
                            this.setState({ isLoading: false })
                        }
                    }
                    else {
                        if (rsp.error_msg) alert(rsp.error_msg)
                        else alert(i18n.t("OrderReview.alert.error.order"))
                        
                        await this.clientPaymentFailed(preparePaymentData)
                        this.setState({ isLoading: false })
                    }
                })
            }
            else {
                throw new Error('preparePayment 마지막 response 실패')
            }
        }
        catch (err) {
            if (type === 'TermPayment') this.termPaymentError('Error', err)
            if (type === 'SubscriptionPayment') this.subscriptionPaymentError(i18n.t("OrderReview.alert.error.subscriptionPaymentError"), err)

            this.setState({ isLoading: false })
        }
    }

    clientPaymentFailed = async preparePaymentData => {
        const clientPaymentFailedResult = await axios.delete(`${GetBaseUrl()}/apis/payments/${preparePaymentData.paymentId}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
        .catch(error => {
            this.clientPaymentFailedError('이니시스/Stripe 취소/실패시 서버로 DELETE /apis/payments/:id 통신하는 부분에서 catch 에러', error)
        })
    
        if (
            clientPaymentFailedResult &&
            clientPaymentFailedResult.status === 200 &&
            clientPaymentFailedResult.data &&
            clientPaymentFailedResult.data.data
        ) this.clientPaymentFailedSuccess()
        else this.clientPaymentFailedError('이니시스/Stripe 취소/실패시 서버로 DELETE /apis/payments/:id 통신은 성공 했으나 결과값이 실패')
    }

    perPaymentSuccess = (templateId, paymentId) => {
        const axiosResult = axios.post(
            `${GetBaseUrl()}/api/video/register`,
            {
                template_id: templateId,
                paymentId
            },
            { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        )

        this.setState({ isLoading: true })

        axiosResult
            .then(res => {
                this.props.orderReviewFinished({
                    result: 'Success',
                    type: 'PerPayment',
                    templateId,
                    templateName: res.data && res.data.template && res.data.template.name,
                    videoId: res.data && res.data._id,
                    withCoupon: false,
                    paymentId: res.data && res.data.paymentInfo && res.data.paymentInfo.paymentId
                })
            })
            .catch(err => {
                alert(i18n.t("myvideo.error.text"))
                this.props.orderReviewFinished({
                    result: 'Error',
                    type: 'PerPayment'
                })
        })
    }

    watermarkPaymentSuccess = () => this.props.history.push('/user/_')
    termPaymentSuccess = () => this.props.orderReviewFinished({ result: 'Success', type: 'TermPayment' })
    termPaymentFailed = (reason, error) => this.props.orderReviewFinished({ result: 'Failed', type: 'TermPayment', reason: reason || '',
    error })
    termPaymentError = (reason, error) => this.props.orderReviewFinished({ result: 'Error', type: 'TermPayment', reason: reason || '', error })
    subscriptionPaymentSuccess = () => this.props.orderReviewFinished({ result: 'Success', type: 'SubscriptionPayment' })
    subscriptionPaymentFailed = (reason, error) => this.props.orderReviewFinished({ result: 'Failed', type: 'SubscriptionPayment', reason: reason || '', error })
    subscriptionPaymentError = (reason, error) => this.props.orderReviewFinished({ result: 'Error', type: 'SubscriptionPayment', reason: reason || '', error })
    issueCouponPaymentSuccess = () => this.props.orderReviewFinished({ result: 'Success', type: 'IssueCoupon', isRemoveWatermark: this.props.location.state.isRemoveWatermark }) 
    issueCouponPaymentFailed = (reason, error) => this.props.orderReviewFinished({ result: 'Error', type: 'IssueCoupon', reason: reason || '', error })

    clientPaymentFailedSuccess = () => this.props.orderReviewFinished({ result: 'Success', type: 'ClientPaymentFailed' })
    clientPaymentFailedError = (reason, error) => this.props.orderReviewFinished({ result: 'Error', type: 'ClientPaymentFailed', reason: reason || '', error })

    renderMethodList = (product, type) => {
        const { whatSelected } = this.state
        const { inicis, kakaopay, stripe, paypal, paypal_v2, naverpay } = product
        const isKo = this.props.value === 'ko'

        const methodList = []

        if (isKo) {
            if (inicis) methodList.push({ key: 'inicis' })
            if (naverpay && sessionStorage.getItem('naverpay')) methodList.push({ key: 'naverpay', img: 'https://front.videomonster.com/images-7cuytg20/web/payment/naverpay.png' })
            if (kakaopay) methodList.push({ key: 'kakaopay', img: 'https://front.videomonster.com/images-7cuytg20/web/payment/kakaopay.png' })
        }
        else {
            if (stripe) methodList.push({ key: 'card', img: 'https://front.videomonster.com/images-7cuytg20/web/payment/visa.png' })
            if (paypal_v2) methodList.push({ key: 'paypal_v2', img: 'https://front.videomonster.com/images-7cuytg20/web/payment/paypal.png' })
            if (paypal && type !== 'SubscriptionPayment') methodList.push({ key: 'paypal', img: 'https://front.videomonster.com/images-7cuytg20/web/payment/paypal.png' })
        }

        if (methodList.length <= 0) {
            alert('Not allowed method.')
            return this.props.history.push('/payment')
        }
        
        return methodList.map((elem) => 
            elem.key === 'inicis' ?
            <div className='order-method-item' onClick={this.handleChangeCheckbox(elem.key)}>
                <div className='method-item'><img src={whatSelected === elem.key ? 'https://front.videomonster.com/images-7cuytg20/web/payment/radiochecked.png' : 'https://front.videomonster.com/images-7cuytg20/web/payment/radio.png'} id={elem.key} /></div>
                <div className='order-method-card'>{i18n.t("detail.payment.method1")}</div>
            </div>
            :
            <div className='order-method-item' onClick={this.handleChangeCheckbox(elem.key)}>
                <div className='method-item'><img src={whatSelected === elem.key ? 'https://front.videomonster.com/images-7cuytg20/web/payment/radiochecked.png' : 'https://front.videomonster.com/images-7cuytg20/web/payment/radio.png'} id={elem.key} /></div>
                <div><img src={elem.img} /></div>
            </div>
        )
    }

    renderOrderInfoType = (type) => {
        let content = null
        const provider = DataManager.GetProvider()

        if (type === PRODUCT_TYPE.SUBSCRIPTION_PAYMENT) content = i18n.t("OrderReview.SubscriptionPayment.subTitle")
        else if (type === PRODUCT_TYPE.TERM_PAYMENT) content = i18n.t("OrderReview.TermPayment1MonthInfo.subTitle")
        else if (type === PRODUCT_TYPE.ISSUE_COUPON && provider === 'cafe24') content = i18n.t("OrderReview.TermPayment1MonthInfo.issueCoupon") // TODO :: 카페 24에서만 사용하여 추후에 번역필요
        else content = i18n.t("OrderReview.PaymentInfo.subTitle")
        return content
    }
    
    renderOrderInfoDes = (type, validity) => {
        if (type === PRODUCT_TYPE.SUBSCRIPTION_PAYMENT) {
            if (validity === 365) return i18n.t("OrderReview.subscription.warning.annually")
            else return i18n.t("OrderReview.subscription.warning.monthly")
        }
        else if (type === PRODUCT_TYPE.ISSUE_COUPON) {
            return i18n.t("OrderReview.issueCoupon.warning") // TODO :: 카페 24에서만 사용하여 추후에 번역필요
        }
    }

    renderRefoundDescription = () => {
        if (DataManager.IsProvider(DataManager.PROVIDER.CAFE24)) {
            return (
                <div className='order-info-description'>
                    <ul>
                        <div>{i18n.t("OrderReview.Refund.descriptionTitle")}</div>
                        <li>1) 번들결제의 경우 사용여부와 관계없이 <span style={{ color: '#ff3131' }} >환불 및 취소가 불가능합니다.</span></li>
                        <li>2) 정기권결제 후 15일이 지나면 사용 여부와 관계없이 <span style={{ color: '#ff3131' }} >환불 및 취소가 불가능합니다.</span></li>
                    </ul>
                </div>
            )
        }

        return (
            <div className='order-info-description'>
                <ul>
                    <div>{i18n.t("OrderReview.Refund.descriptionTitle")}</div>
                    <li>1) <Trans i18nKey="OrderReview.Refund.descriptionContent1" components={[<span style={{ color: '#ff3131' }} />]} /></li>
                    <li>2) <Trans i18nKey="OrderReview.Refund.descriptionContent2" components={[<span style={{ color: '#ff3131' }} />]} /></li>
                </ul>
            </div>
        )
    }

    renderSubscriptionInstruction = (type, validity) => {
        if (type !== 'SubscriptionPayment') return null
        
        let transKey = "OrderReview.SubscriptionPayment.descriptionContent1"
        if (validity === 365) transKey = "OrderReview.SubscriptionPayment.descriptionContent1.annual"

        return (
            <div className='order-info-description'>
                <ul>
                    <div>{i18n.t("OrderReview.SubscriptionPayment.descriptionTitle")}</div>
                    <li>1) <Trans i18nKey={transKey} components={[<span style={{ color: '#ff3131' }} />]} /></li>
                    <li>2) {i18n.t("OrderReview.SubscriptionPayment.descriptionContent2")}</li>
                    <li>3) {i18n.t("OrderReview.SubscriptionPayment.descriptionContent4")}</li>
                </ul>
            </div>
        )
    }

    render() {
        const { couponCode, selectedCoupon, isAgreed, isCouponPopupOpen, isUploadCompletedOpened, isLoading } = this.state

        const product = this.getPaymentInfoByType()
        if (!product) return <Loading />

        const { productId } = this.props.history.location.state

        const { productPrice, type, currency, validity } = product
        const calculatedPrice = this.calculateFinalPrice(productPrice)

        const productName = product.productName[this.props.value] ? product.productName[this.props.value] : product.productName['en']
        const isDiscountAll = (selectedCoupon && selectedCoupon.data && selectedCoupon.data.action === 'DiscountAll')
        
        return (
            <div className='order-new-root-container prohibit-drag'>
                <div className='order-title'>{i18n.t("OrderReview.TermPayment1MonthInfo.title")}</div>
                <div className='order-body'>
                    <div className='order-body-left'>
                        <div className='order-method'>
                            <div className='order-method-title'>{i18n.t("OrderReview.payment.method")}</div>
                            <div className='order-method-list'>
                                {this.renderMethodList(product, type)}
                            </div>
                        </div>
                        <div className='order-coupon'>
                            <div className='order-coupon-title'>{i18n.t("coupon.title")}</div>
                            <div className='order-coupon-body'>
                                <div className='order-coupon-list'>
                                    <div className='coupon-item'>
                                        <div className='available-coupon'>{selectedCoupon ? selectedCoupon.name[this.props.value] : i18n.t("couponright.no.coupon")}</div>
                                    </div>
                                </div>
                                {
                                    selectedCoupon ?
                                    <div className='order-coupon-text' onClick={this.handleCancelCouponSelect}>
                                        <div className='line1' />
                                        <div className='line2' />
                                    </div>
                                    :
                                    <div className='order-coupon-button' onClick={this.handleClickCouponPopupBtn}>
                                        {i18n.t("couponright.use.coupon")}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='order-body-right'>
                        <div className='order-info'>
                            <div className='order-info-title'>
                                {i18n.t("couponRight.title")}
                            </div>
                            {
                                !isDiscountAll &&
                                <div className='order-info-method-area'>
                                    <div className='order-info-method'>
                                        {i18n.t("couponright.way.payment")}
                                    </div>
                                    <div className='order-info-method-type'>
                                        <span>{this.renderOrderInfoType(type)}</span>
                                        <div className='order-info-method-des'>
                                            <span>{this.renderOrderInfoDes(type, validity)}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className='order-info-amount'>
                                <div className='order-info-amount-montly'>
                                    <div className='order-info-montly-subtitle'>{productName}</div>
                                    <div className='order-info-montly-pay'><span>{currencyTable[currency]} </span>{new Intl.NumberFormat().format(productPrice)}</div>
                                </div>
                                <div className='order-info-amount-coupon'>
                                    <div className='order-info-coupon'>{i18n.t("designselectpopup.use.coupon.btn")}</div>
                                    <div className='order-info-coupon-pay'>- <span>{currencyTable[currency]} </span>{new Intl.NumberFormat().format(productPrice - calculatedPrice)}</div>
                                </div>
                                <div className='order-info-amount-total'>
                                    <div className='order-info-total-subtitle'>{i18n.t("couponright.will.payment")}</div>
                                    <div className='order-info-total-pay'><span>{currencyTable[currency]} </span>{new Intl.NumberFormat().format(calculatedPrice)}</div>
                                </div>
                            </div>
                            {
                                !isDiscountAll &&
                                <div className='order-info-description-area'>
                                    {this.renderRefoundDescription()}
                                    {this.renderSubscriptionInstruction(type, validity)}
                                </div>
                            }
                            <div className='order-info-agree-area'>
                                <div className='order-info-agree'>
                                    <label><input type="checkbox" name="agree" value={isAgreed} onClick={this.handleClickAgreement} />{i18n.t("couponright.ask.agree")}</label>
                                </div>
                            </div>
                            <div className='order-info-payment-area'>
                                <div className='order-info-payment-button' onClick={this.handleClickOrderBtn}>{i18n.t("couponright.final.use.payment")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <CouponPopup
                    open={isCouponPopupOpen}
                    onClose={this.handleClickCloseCouponPopup}
                    handleSelectCoupon={this.handleSelectCoupon}
                    handleChangeCouponCode={this.handleChangeCouponCode}
                    handleClickRegisterCouponBtn={this.handleClickRegisterCouponBtn}
                    coupons={this.props.coupons}
                    productId={productId}
                    couponCode={couponCode}
                />
                <UploadCompleted
                    DesignedButtonText={i18n.t("global.confirm")}
                    dialogBodyText1={i18n.t("OrderReview.UploadCompleted.dialogBodyText1")}
                    dialogBodyText2={i18n.t("OrderReview.UploadCompleted.dialogBodyText2")}
                    dialogHeadText={i18n.t("signup.agree.text")}
                    open={isUploadCompletedOpened}
                    closeUploadCompletedDialog={this.handleCloseUploadCompletedDialog}
                    closeBtn={this.handleCloseDialog}
                />
                <Uploading open={isLoading} progress={0}>{i18n.t("OrderReview.Uploading.title")}</Uploading>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    coupons: state.couponStore.coupons
})

export default connect(
    mapStateToProps,
    null
)(OrderClass)